<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qy3wwW/tc-custom/9781460331668.jpg?1703823903602" alt="This image is the cover for the book Return of the Prodigal Gilvry, The Gilvrys of Dunross"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return of the Prodigal Gilvry, The Gilvrys of Dunross
      </h1>
      <p class="bookDescription body article font2">
        <b>A highlander seeking revenge must keep his promise to help a beautiful widow in this Scottish historical romance.</b><br/><br/><i>Dundee, Scotland, 1822</i>. Though he bears the scars of betrayal, Andrew Gilvry was once a devastatingly handsome man. Though he craves vengeance for his brother’s treachery, he has returned to Scotland to fulfill a noble promise made to a dying man. The widowed Rowena MacDonald has been entrusted to his care, and Drew must do all he can to protect her. . . .<br/><br/>But Drew’s honor is about to be tested—because there’s something in Rowena’s dove-gray eyes that awakens a flame long extinguished. And on a perilous journey across the Highlands, with only this alluring woman for company, how long can he deny his desires?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Lethbridge
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b1a04d4